/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import {
  FETCH_ACES_CHAP_BURIAL_PROVIDER_SEARCH,
  FETCH_ACES_CHAP_INSURANCE_PROVIDER_SEARCH,
} from './actionTypes';

import {
  fetchAcesChapBurialProviderSearchUtil,
  fetchAcesChapInsuranceProviderSearchUtil,
} from './utils';

/**
 * Contains the action creator functions that update the ACESProviderSearch slice of the store.
 *
 * @namespace ACESProviderSearchActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/aces_chap_burial_provider_search
   *
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof ACESProviderSearchActions
   */
  static fetchAcesChapBurialProviderSearch = (dispatch, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      fetchAcesChapBurialProviderSearchUtil,
      FETCH_ACES_CHAP_BURIAL_PROVIDER_SEARCH,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to fetchAcesChapBurialProviderSearch.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof ACESProviderSearchActions
   */
  static resetFetchAcesChapBurialProviderSearch = (dispatch, data) => {
    const json = {
      type: FETCH_ACES_CHAP_BURIAL_PROVIDER_SEARCH.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to fetchAcesChapBurialProviderSearch.
   *
   * @param {function} dispatch
   * @function
   * @memberof ACESProviderSearchActions
   */
  static resetFetchAcesChapBurialProviderSearchError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, FETCH_ACES_CHAP_BURIAL_PROVIDER_SEARCH.failureAction);
  };

  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/aces_chap_insurance_provider_search
   *
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof ACESProviderSearchActions
   */
  static fetchAcesChapInsuranceProviderSearch = (dispatch, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      fetchAcesChapInsuranceProviderSearchUtil,
      FETCH_ACES_CHAP_INSURANCE_PROVIDER_SEARCH,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to fetchAcesChapInsuranceProviderSearch.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof ACESProviderSearchActions
   */
  static resetFetchAcesChapInsuranceProviderSearch = (dispatch, data) => {
    const json = {
      type: FETCH_ACES_CHAP_INSURANCE_PROVIDER_SEARCH.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to fetchAcesChapInsuranceProviderSearch.
   *
   * @param {function} dispatch
   * @function
   * @memberof ACESProviderSearchActions
   */
  static resetFetchAcesChapInsuranceProviderSearchError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, FETCH_ACES_CHAP_INSURANCE_PROVIDER_SEARCH.failureAction);
  };
}
